var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "createProductDialog",
          attrs: {
            visible: _vm.dialogVisible,
            width: "53%",
            "show-close": false,
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "title" }, [
            _c("p", [_vm._v("生成参考酒店")]),
          ]),
          _c(
            "div",
            { staticClass: "content" },
            [
              _vm._l(_vm.stockObj, function (item, index) {
                return _c(
                  "div",
                  { key: index },
                  [
                    item.startDate
                      ? _c("span", { staticStyle: { width: "2rem" } }, [
                          _vm._v(
                            _vm._s(item.startDate) + "至" + _vm._s(item.endDate)
                          ),
                        ])
                      : _vm._e(),
                    _c("span", { staticStyle: { width: "1.5rem" } }, [
                      _vm._v(_vm._s(item.productNameCn)),
                    ]),
                    _c("span", [_vm._v("销售价格")]),
                    _c("el-input", {
                      attrs: { size: "mini" },
                      model: {
                        value: item.salePrice,
                        callback: function ($$v) {
                          _vm.$set(item, "salePrice", $$v)
                        },
                        expression: "item.salePrice",
                      },
                    }),
                    _c("span", [_vm._v("option时间")]),
                    _c("el-date-picker", {
                      staticStyle: { width: "1.7rem" },
                      attrs: {
                        format: "yyyy-MM-dd HH",
                        type: "datetime",
                        placeholder: "选择日期时间",
                      },
                      model: {
                        value: item.optionDate,
                        callback: function ($$v) {
                          _vm.$set(item, "optionDate", $$v)
                        },
                        expression: "item.optionDate",
                      },
                    }),
                  ],
                  1
                )
              }),
              _c(
                "div",
                [
                  _c("el-button", { on: { click: _vm.save } }, [
                    _vm._v("保存并加入行程轴"),
                  ]),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.dialogVisible = false
                        },
                      },
                    },
                    [_vm._v("关闭")]
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }